module.exports = __webpack_public_path__ + "static/media/bg-score.8b5b4af6.svg";